<ng-container>
  <p>Distribuição de leads por produto</p>
  <div class="lead-management-content">
    <div *ngIf="loading" class="loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <table
    mat-table 
    [dataSource]="dataSource" 
    aria-describedby="Overview"
    matSort 
    matSortActive="leads" 
    matSortDirection="desc"
    matSortDisableClear="true" 
    (matSortChange)="sortTable($event)"
    [summary]="'Distribuição de leads por produto'"
    class="mat-elevation">

      <ng-container matColumnDef="produto">
        <th mat-header-cell *matHeaderCellDef scope="col">Produto</th>
        <td mat-cell *matCellDef="let element" >
          <ng-container *ngIf="element.product_name">
            {{element.product_name}}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="leads">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="receivedLead"> Leads recebidos </th>
        <td mat-cell *matCellDef="let element"> 
          <ng-container *ngIf="element.received_lead_amount">
            {{element.received_lead_amount}}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="fila">
        <th mat-header-cell *matHeaderCellDef scope="col"> Fila </th>
        <td mat-cell *matCellDef="let element"> 
          <ng-container *ngIf="element.queue_name">
            {{element.queue_name}}
          </ng-container>        
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator
      #paginator 
      [pageIndex]="0"
      [pageSizeOptions]="[5, 10, 20]"
      [length]="total" 
      [pageSize]="maxResults"
      (page)="pageChange($event)"
      >
    </mat-paginator>
    
  </div>
</ng-container>